function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__n"
}, /*#__PURE__*/React.createElement("path", {
  d: "M325.605 236.832c-3.726 0-6.816-1.441-9.48-4.363-2.66-2.922-3.973-6.23-3.973-10.13 0-4.089 1.313-7.437 3.973-10.241 2.664-2.844 5.79-4.207 9.516-4.207s6.812 1.363 9.511 4.207c2.664 2.843 3.977 6.191 3.977 10.242 0 3.898-1.313 7.207-3.977 10.129-2.734 2.922-5.855 4.363-9.547 4.363zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M370 0h371v164H370zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M414 30h31v30h-31zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M429.59 59.766c-4.09 0-7.48-1.473-10.402-4.461-2.922-2.985-4.364-6.367-4.364-10.348 0-4.18 1.442-7.605 4.363-10.508 2.922-2.906 6.352-4.3 10.442-4.3 4.094 0 7.484 1.394 10.445 4.3 2.922 2.903 4.363 6.328 4.363 10.508 0 3.98-1.44 7.363-4.363 10.348-3 2.988-6.39 4.46-10.484 4.46zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M459 30h30v30h-30zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M474.035 59.766c-4.098 0-7.492-1.473-10.418-4.461-2.926-2.985-4.37-6.367-4.37-10.348 0-4.18 1.444-7.605 4.37-10.508 2.926-2.906 6.36-4.3 10.457-4.3 4.055 0 7.567 1.433 10.457 4.3 2.926 2.903 4.328 6.328 4.328 10.508 0 3.98-1.441 7.363-4.367 10.348-2.89 2.945-6.398 4.46-10.457 4.46zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  d: "M192 207h28v30h-28zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  d: "M206.41 236.832c-3.726 0-6.816-1.441-9.476-4.363-2.66-2.922-3.977-6.23-3.977-10.13 0-4.089 1.316-7.437 3.977-10.241 2.66-2.844 5.785-4.207 9.511-4.207 3.727 0 6.817 1.363 9.516 4.207 2.66 2.843 3.973 6.191 3.973 10.242 0 3.898-1.313 7.207-3.973 10.129-2.734 2.922-5.824 4.363-9.55 4.363zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  d: "M227 207h28v30h-28zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__j"
}, /*#__PURE__*/React.createElement("path", {
  d: "M240.559 236.832c-3.727 0-6.817-1.441-9.477-4.363-2.664-2.922-3.977-6.23-3.977-10.13 0-4.089 1.313-7.437 3.977-10.241 2.66-2.844 5.785-4.207 9.512-4.207 3.726 0 6.812 1.363 9.511 4.207 2.665 2.843 3.977 6.191 3.977 10.242 0 3.898-1.312 7.207-3.977 10.129-2.734 2.922-5.82 4.363-9.546 4.363zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__k"
}, /*#__PURE__*/React.createElement("path", {
  d: "M278 207h27v30h-27zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__l"
}, /*#__PURE__*/React.createElement("path", {
  d: "M291.457 236.832c-3.727 0-6.816-1.441-9.477-4.363-2.664-2.922-3.976-6.23-3.976-10.13 0-4.089 1.312-7.437 3.976-10.241 2.66-2.844 5.786-4.207 9.512-4.207 3.727 0 6.852 1.363 9.516 4.207 2.66 2.843 3.972 6.191 3.972 10.242 0 3.898-1.312 7.207-3.972 10.129-2.735 2.922-5.824 4.363-9.551 4.363zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__m"
}, /*#__PURE__*/React.createElement("path", {
  d: "M312 207h28v30h-28zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M476.695 163.418c-4.632 0-9.023-1.043-13.035-3.129-4.039-2.086-7.734-4.965-11.012-8.523l-.73-.793-.734.793c-3.239 3.558-6.97 6.437-11.012 8.523-4.008 2.086-8.293 3.129-12.719 3.129h-12.582a48.852 48.852 0 01-16.902-3.023c-5.508-1.977-10.422-5.106-14.707-9.313-3.871-3.598-7.008-8.02-9.34-13.273-2.336-5.215-3.52-11.293-3.52-18.016V21.285L396.645.535v119.258c0 4.781 1.46 8.738 4.355 11.723a15.303 15.303 0 006.344 3.957c1.078.359 2.265.648 3.484.828h16.625c1.777 0 3.867-1.512 6.41-4.57a29.534 29.534 0 003.766-6.543c.976-2.376 1.496-4.641 1.496-6.727v-14.492l25.895-20.5v13.664h.035v21.328c0 2.086.488 4.316 1.5 6.727a30.846 30.846 0 003.73 6.542c2.543 3.094 4.633 4.606 6.41 4.606H740.59c-2.23 5.504-5.367 10.215-9.41 14.098a47.846 47.846 0 01-15.196 9.816c-5.297 2.09-11.187 3.168-17.496 3.168zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__o"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h341v223H0zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__p"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.906 222.648c-2.242-.035-4.414-.175-6.52-.347h-1.171c-12.242 0-22.828-3.899-31.485-11.63-7.414-6.401-11.69-14.722-12.726-24.745-.516-2.856-.793-5.64-.793-8.32 0-2.579.242-5.223.723-7.903.898-9.922 5.382-18.52 13.347-25.617 9.035-8.078 19.45-12.149 30.969-12.149h187.527c3.965-.628 7.313-2.195 10.036-4.632 2.898-2.922 4.378-6.75 4.378-11.38V20.583L272.851.535v115.39c0 2.434.446 4.63 1.344 6.509.864 1.843 1.965 3.48 3.278 4.804a15.103 15.103 0 006.308 3.828c1.07.348 2.207.625 3.45.801h53.554c-2.207 5.324-5.312 9.887-9.312 13.645-4.344 4.07-9.414 7.273-15.036 9.504-4.136 1.597-8.066 2.922-14.207 2.922l-14.449.035c-.828 0-1.586 0-1.965-.036-4.277-.277-6.55-1.078-9.484-2.09l-1.586-.554c-5.101-1.742-9.793-4.527-13.93-8.25l-.656-.594-.656.559c-4.207 3.656-9.07 6.441-14.414 8.285a50.993 50.993 0 01-13.692 2.644l-1.894.106.031.035H45.215c-4.172 0-7.793 1.426-11.348 4.453-3.652 3.098-5.586 6.824-5.586 10.793v7.656c0 10.094 5.692 15.247 16.934 15.247l116.215.175-.07.102.343.035c-2.238 5.293-5.445 9.852-9.516 13.543-4.414 4.035-9.585 7.168-15.347 9.398-5.309 1.985-11.242 3.028-17.621 3.028h-.45l-.035.07H52.906zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__q"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 252h164v164H0zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__r"
}, /*#__PURE__*/React.createElement("path", {
  d: "M44 415.145l-.484-.07c-6.438 0-12.418-1.063-17.774-3.18a48.44 48.44 0 01-15.48-9.868c-4.137-3.91-7.407-8.77-9.668-14.394l119.336-.184c11.304 0 17.043-5.37 17.043-16.004v-8.035c0-4.129-1.946-8.039-5.633-11.328-3.582-3.18-7.235-4.676-11.445-4.676h-2.61v.07H45.602c-11.618 0-22.157-4.273-31.235-12.75-8-7.453-12.52-16.476-13.426-26.78-.488-2.887-.73-5.7-.73-8.403 0-2.816.277-5.738.766-8.66 1.043-10.598 5.355-19.328 12.835-26.016 9.008-8.367 19.72-12.605 31.79-12.605 0 0 2.433.035 4.695.035 1.148 0 2.297 0 3.062-.035h65.91l.489.074c6.433 0 12.414 1.059 17.773 3.18a48.346 48.346 0 0115.477 9.863c4.14 3.945 7.41 8.77 9.668 14.394l-119.23.184c-11.305 0-17.079 5.371-17.079 16.004V304c0 4.129 1.95 8.04 5.633 11.324 3.586 3.18 7.238 4.68 11.445 4.68h2.504v-.074h71.754c11.617 0 22.156 4.273 31.234 12.75 8 7.453 12.524 16.48 13.426 26.78.489 2.888.73 5.704.73 8.407 0 2.813-.277 5.735-.765 8.66-1.043 10.594-5.355 19.328-12.832 26.012-9.043 8.367-19.723 12.606-31.793 12.606l-5.46-.036c-.766 0-1.528 0-2.294.036zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__s"
}, /*#__PURE__*/React.createElement("path", {
  d: "M710 252h31v164h-31zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__t"
}, /*#__PURE__*/React.createElement("path", {
  d: "M710.973 415.11V296.52c0-6.668 1.183-12.86 3.46-18.391 2.52-6.012 6.137-11.36 10.739-15.977 4.207-4.21 9.398-7.547 15.418-9.89v162.883h-29.617zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__u"
}, /*#__PURE__*/React.createElement("path", {
  d: "M548 252h134v164H548zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__v"
}, /*#__PURE__*/React.createElement("path", {
  d: "M592.57 415.145a48.14 48.14 0 01-16.906-3.075c-5.508-2.015-10.422-5.234-14.71-9.484-3.868-3.66-7.005-8.164-9.34-13.508-2.337-5.344-3.524-11.496-3.524-18.344V276.06l.07-2.524v-21.273c5.336 2.343 9.903 5.636 13.664 9.886 4.082 4.614 7.29 9.993 9.52 15.961 2.02 5.567 3.066 11.754 3.066 18.38v8.273l-.07 1.027v64.582c0 4.867 1.465 8.895 4.36 11.934a15.257 15.257 0 006.343 4.027c1.078.367 2.23.66 3.484.844h92.832c-2.336 5.894-5.472 10.836-9.414 14.68a47.757 47.757 0 01-15.195 9.996c-5.3 2.12-11.191 3.218-17.5 3.218h-46.68zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__w"
}, /*#__PURE__*/React.createElement("path", {
  d: "M177 252h164v164H177zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__x"
}, /*#__PURE__*/React.createElement("path", {
  d: "M245.996 415.145V280.043h-23.691c-6.614 0-12.805-1.098-18.336-3.254a50.805 50.805 0 01-15.918-10.09c-4.375-4.094-7.875-9.062-10.149-14.437h162.883c-2.344 5.668-5.633 10.492-9.832 14.437-4.586 4.317-9.937 7.715-15.922 10.09-5.457 2.121-10.008 2.633-18.406 3.254h-23.969v135.102zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__y"
}, /*#__PURE__*/React.createElement("path", {
  d: "M370 252h164v164H370zm0 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__z"
}, /*#__PURE__*/React.createElement("path", {
  d: "M533.285 254.7c-3.355-1.243-6.742-2.009-10.094-2.302a33.606 33.606 0 00-6.078 0c-5.902.477-11.629 2.118-17.078 4.856-5.027 2.555-9.707 6.281-13.898 10.988l-34.293 34.098-34.297-34.098c-4.192-4.707-8.871-8.433-13.899-10.988-5.414-2.738-11.175-4.379-17.078-4.856a33.606 33.606 0 00-6.078 0c-3.351.293-6.738 1.059-10.09 2.301l67.961 71.262v89.184h26.61v-88.93zm0 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M365.402-4.465H745.59v172.883H365.402zm0 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__c)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M409.824 25.148h39.613v39.618h-39.613zm0 0"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__e)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M454.246 25.148h39.613v39.618h-39.613zm0 0"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__g)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M187.957 202.89h36.977v38.942h-36.977zm0 0"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__i)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M222.105 202.89h36.977v38.942h-36.977zm0 0"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__k)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M273.004 202.89h36.976v38.942h-36.976zm0 0"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__m)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__n)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M307.152 202.89h36.977v38.942h-36.977zm0 0"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__o)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__p)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4.79-4.465h350.575v232.113H-4.789zm0 0"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__q)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__r)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4.79 247.262h172.884v172.883H-4.79zm0 0"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__s)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__t)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M705.973 247.262h39.617v172.883h-39.617zm0 0"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__u)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__v)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M543.09 247.262h143.27v172.883H543.09zm0 0"
})));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__w)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__x)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M172.902 247.262h172.883v172.883H172.902zm0 0"
})));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__y)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__z)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M365.402 247.262h172.883v172.883H365.402zm0 0"
})));

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 988,
    height: "416pt",
    viewBox: "0 0 741 416"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

export default SvgLogo;